import Vue from "vue";
import VueRouter from "vue-router";
import AnytimeExamination from "../views/AnytimeExamination.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/anytime-examination",
    name: "anytime-examination",
    component: AnytimeExamination
  },
  // {
  //   path: "/",
  //   name: "home",
  //   component: Home
  // },
  // {
  //   path: "/backup",
  //   name: "backup",
  //   component: Home
  // },
  // {
  //   path: "/color-box",
  //   name: "color-box",
  //   component: () =>
  //     import(/* webpackChunkName: "color-box" */ "../views/ColorBox.vue")
  // },
  // {
  //   path: "/anytime-examination",
  //   name: "anytime-examination",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "anytime-examination" */ "../views/AnytimeExamination.vue"
  //     )
  // },
  {
    path: "/",
    name: "download",
    component: () =>
      import(/* webpackChunkName: "download" */ "../views/Download.vue")
  },
  {
    path: "/introduce",
    name: "introduce",
    component: () =>
      import(/* webpackChunkName: "introduce" */ "../views/Introduce.vue")
  }
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // }
];

const router = new VueRouter({
  routes
});

export default router;
